import { useTranslation } from 'react-i18next'
import omit from 'lodash-es/omit'

import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../../../constants/route'
import {
  EntityProfileHeader,
  EntityProfileHeaderTitleBackButton,
  EntityProfileHeaderTitleWithStatus,
} from '../../../../Entity'
import {
  MultipleViewTypeListActiveItemPreviewHeaderActions,
  MultipleViewTypeListActiveItemPreviewHeaderToggle,
} from '../../../../MultipleViewTypeList'
import {
  getIsListingPublishBlocked,
  RentalPortalListingAlreadyPublishedChip,
} from '../../../../RentalPortalListing'
import { useListingProfileContext } from '../RentalPortalListingProfile.hooks'
import { RentalPortalListingProfileHeaderFooter } from '../RentalPortalListingProfileHeaderFooter'
import { RentalPortalListingProfileHeaderInfoItems } from '../RentalPortalListingProfileHeaderInfoItems'
import { RentalPortalListingProfileHeaderStatusSelect } from '../RentalPortalListingProfileHeaderStatusSelect'

import { QA_NAME_LISTING_PROFILE_HEADER_EDIT_TITLE } from './RentalPortalListingProfileHeader.constants'
import { useListingProfileHeader } from './RentalPortalListingProfileHeader.hooks'
import {
  getCanEditListingTitle,
  getListingProfileHeaderAvatarProps,
} from './RentalPortalListingProfileHeader.utils'

import * as styles from './RentalPortalListingProfileHeader.module.css'

function RentalPortalListingProfileHeader({
  isPreview,
  openFullPageActionsProps,
}) {
  const { t } = useTranslation()

  const { isInitiated, listingData } = useListingProfileContext()

  const { coverSrc, handleCoverError, handleOpenEditTitleModal, listingTitle } =
    useListingProfileHeader()

  return (
    <EntityProfileHeader
      Content={null}
      Footer={isPreview ? null : RentalPortalListingProfileHeaderFooter}
      Header={EntityProfileHeaderTitleWithStatus}
      InfoItems={RentalPortalListingProfileHeaderInfoItems}
      headerProps={{
        ...(isPreview
          ? {
              ToggleButton: MultipleViewTypeListActiveItemPreviewHeaderToggle,
              toggleButtonProps: {
                onClosePreview: openFullPageActionsProps?.onClosePreview,
              },
            }
          : null),
        Actions: openFullPageActionsProps
          ? MultipleViewTypeListActiveItemPreviewHeaderActions
          : null,
        BackButton: isPreview ? null : EntityProfileHeaderTitleBackButton,
        Status: RentalPortalListingProfileHeaderStatusSelect,
        actionsProps: openFullPageActionsProps
          ? {
              ...omit(openFullPageActionsProps, 'onClosePreview'),
              Actions: null,
            }
          : null,
        entityAvatarProps: getListingProfileHeaderAvatarProps({
          alt: listingTitle,
          className: styles.avatar,
          src: coverSrc,
          t,
          onError: handleCoverError,
        }),
        sectionBackUrl: `/${ROUTE_PATH_LIST_RENTAL_PORTAL.root}/${ROUTE_PATH_LIST_RENTAL_PORTAL.listings}`,
        statusProps: {
          className: styles.statusSelect,
          disabled: !listingData?.permissions?.can_publish,
        },
        text: listingTitle,
        textPlaceholder: t('RentalPortal.ListingProfileHeaderNoTitleKey'),
        textProps: {
          additionalIcons: getIsListingPublishBlocked(listingData) ? (
            <RentalPortalListingAlreadyPublishedChip
              flatPublishedListing={listingData.flat_published_listing}
            />
          ) : null,
          editable: !isPreview && getCanEditListingTitle(listingData),
          editButtonQaName: QA_NAME_LISTING_PROFILE_HEADER_EDIT_TITLE,
        },
      }}
      infoItemsProps={{ isPreview }}
      isLoading={!isInitiated}
      onClickEditTitleButton={handleOpenEditTitleModal}
    />
  )
}

export default RentalPortalListingProfileHeader
